class BodyPillowCaseGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener(
      "body-pillow-case::product-change",
      this.productChangeEventHandler.bind(this)
    );
  }

  productChangeEventHandler(event) {
    const { handle } = event.detail;
    this.filterGallery(handle);
  }

  filterGallery(handle) {
    let currentGallery = this.querySelector(`.pillow-case-gallery.flex`);
    let newActiveGallery = this.querySelector(
      `.pillow-case-gallery[data-product-handle="${handle}"]`
    );

    currentGallery.classList.remove("flex");
    currentGallery.classList.add("hidden");

    newActiveGallery.classList.remove("hidden");
    newActiveGallery.classList.add("flex");
  }

  disconnectedCallback() {}
}
customElements.define("body-pillow-case-gallery", BodyPillowCaseGallery);
